import { Box, Link, Paper, Typography } from '@mui/material';
import moment from 'moment';
import { NavLinkComponent } from '../../Router';
import NavLink from '../../components/NavLink';
import { DataListComponent, NoDataPaper } from '../../components/data/DataTable';
import { Meter } from '../../models/Types';
import { houseStore } from '../houses/HouseCombo';
import { moneyFormat, parseValidDate } from '../../utils';
import { tariffStore } from '../project/tariff/TariffCombo';

const styles = {
    mobileListItem: {
        display: 'flex',
        flexDirection: 'column!important',
        justifyContent: 'space-between',
        textDecoration: 'none',
        p: 2,
        gap: 2,
        alignItems: 'flex-start',
        "&>*": {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            gap: .5
        }
    }
}

export function buildMeterListItem(x: Meter) {
    return <Paper component={NavLinkComponent} sx={styles.mobileListItem} elevation={2} route={[['page', 'meter'], ['id', x.Id]]}>
        <Box>
            <Link variant="h3">№{x.Number}</Link>
            <Typography variant="subtitle2">{houseStore.data?.find(h => h.Id == x.HouseId)?.Value}</Typography>
        </Box>
        <Box>
            <Typography variant="body2">{x.Tariffs.map(v => tariffStore.data?.filter(x => x.Id == v).map(x => x.Value)).join(', ')}</Typography>
            <Typography variant="h4">{parseValidDate(x.NextCheck) ? moment(parseValidDate(x.NextCheck)).calendar() : null}</Typography>
        </Box>
    </Paper>;
}

export function noDataRenderer() {
    return <NoDataPaper title="Платежей пока нет" content={['В этом разделе будут отображаться платежи, поступившие в УК']} />;
}

export default class MeterList extends DataListComponent<Meter> {
    renderNoData() {
        return noDataRenderer();
    }

    buildItemPaper(x: Meter, i: number) {
        return buildMeterListItem(x);
    }
}